import { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import flyer from '../assets/flyer.png';

const POPUP_DELAY_MS = 4000;
// const POPUP_COOLDOWN_DAYS = 1;
const POPUP_COOLDOWN_DAYS = 0.0208;

export default function PromoPopup() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const dismissed = localStorage.getItem('igrade_popup_dismissed');
    if (dismissed) {
      const daysSince = (Date.now() - parseInt(dismissed)) / (1000 * 60 * 60 * 24);
      if (daysSince < POPUP_COOLDOWN_DAYS) return;
    }
    const timer = setTimeout(() => setVisible(true), POPUP_DELAY_MS);
    return () => clearTimeout(timer);
  }, []);

  const close = () => {
    setVisible(false);
    localStorage.setItem('igrade_popup_dismissed', Date.now().toString());
  };

  return (
    <AnimatePresence>
      {visible && (
        <>
          {/* Backdrop — flex centered */}
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            onClick={close}
            style={{
              position: 'fixed',
              inset: 0,
              zIndex: 1100,
              background: 'rgba(7,21,53,0.82)',
              backdropFilter: 'blur(4px)',
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              padding: '20px',
            }}
          >
            {/* Popup — stop click propagation so closing only on backdrop */}
            <motion.div
              initial={{ opacity: 0, scale: 0.88, y: 40 }}
              animate={{ opacity: 1, scale: 1, y: 0 }}
              exit={{ opacity: 0, scale: 0.92, y: 20 }}
              transition={{ duration: 0.45, ease: [0.22, 1, 0.36, 1] }}
              onClick={(e) => e.stopPropagation()}
              style={{
                position: 'relative',
                width: '100%',
                maxWidth: 500,
                maxHeight: '90vh',
                overflowY: 'auto',
                borderRadius: 16,
                overflow: 'hidden',
                boxShadow: '0 32px 100px rgba(0,0,0,0.6)',
              }}
            >
              {/* Close button */}
              <button
                onClick={close}
                style={{
                  position: 'absolute', top: 12, right: 12, zIndex: 10,
                  width: 32, height: 32, borderRadius: '50%',
                  background: 'rgba(0,0,0,0.55)', border: 'none',
                  color: '#fff', fontSize: 16, cursor: 'pointer',
                  display: 'grid', placeItems: 'center',
                  backdropFilter: 'blur(4px)',
                  transition: 'background 0.2s',
                  fontFamily: 'DM Sans,sans-serif',
                }}
                onMouseEnter={e => e.currentTarget.style.background = 'rgba(0,0,0,0.85)'}
                onMouseLeave={e => e.currentTarget.style.background = 'rgba(0,0,0,0.55)'}
              >✕</button>

              {/* Flyer image */}
              <img
                src={flyer}
                alt="iGrade Education — Ambitious Careers, Empowered Choices"
                style={{ width: '100%', display: 'block' }}
              />

              {/* CTA strip */}
              <div style={{
                background: 'var(--navy)',
                padding: '16px 24px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                gap: 12,
                flexWrap: 'wrap',
              }}>
                <p style={{ color: 'rgba(255,255,255,0.75)', fontSize: 13, margin: 0 }}>
                  Ready to start your journey?
                </p>
                <a
                  href="#contact"
                  onClick={close}
                  style={{
                    background: 'var(--yellow)', color: 'var(--navy)',
                    padding: '10px 22px', borderRadius: 8,
                    fontWeight: 800, fontSize: 14, whiteSpace: 'nowrap',
                    transition: 'all 0.2s',
                  }}
                  onMouseEnter={e => e.currentTarget.style.background = '#FFD740'}
                  onMouseLeave={e => e.currentTarget.style.background = 'var(--yellow)'}
                >
                  Book Free Counselling →
                </a>
              </div>
            </motion.div>
          </motion.div>
        </>
      )}
    </AnimatePresence>
  );
}